"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexBoxRow = exports.FlexBoxCol = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Col = _interopRequireDefault(require("./components/Col"));

var _Row = _interopRequireDefault(require("./components/Row"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlexBoxRow = function FlexBoxRow(props) {
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], _extends({
    "data-test": "row"
  }, props));
};

exports.FlexBoxRow = FlexBoxRow;

var FlexBoxCol = function FlexBoxCol(props) {
  return /*#__PURE__*/_react["default"].createElement(_Col["default"], _extends({
    "data-test": "col"
  }, props));
};

exports.FlexBoxCol = FlexBoxCol;
var ResponsiveName = ['xs', 'sm', 'md', 'lg'];

var ResponsiveType = _propTypes["default"].oneOf(ResponsiveName);

FlexBoxRow.propTypes = {
  reverse: _propTypes["default"].bool,
  start: ResponsiveType,
  center: ResponsiveType,
  end: ResponsiveType,
  top: ResponsiveType,
  middle: ResponsiveType,
  bottom: ResponsiveType,
  around: ResponsiveType,
  between: ResponsiveType,
  first: ResponsiveType,
  last: ResponsiveType,
  children: _propTypes["default"].node
};
var DimensionPropTypes = ResponsiveName.reduce(function (propTypes, dimension) {
  propTypes[dimension] = _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].bool]);
  propTypes[dimension + 'Offset'] = _propTypes["default"].number;
  return propTypes;
}, {});
FlexBoxCol.propTypes = _objectSpread(_objectSpread({}, DimensionPropTypes), {}, {
  reverse: _propTypes["default"].bool,
  children: _propTypes["default"].node
});